import React, { useState } from 'react';
import uae_image from '@assets/pictures/Flag_of_the_United_Arab_Emirates.svg.png';
import oman_flag from '@assets/pictures/Oman_logo.png';
import config from '@components/config';
import starLogo from '@assets/pictures/star_logo.png';

const CountrySelection = () => {
  const environment = getEnvironment();
  const [isNavigating, setIsNavigating] = useState(false);

  const countries = config[environment].map((country) => ({
    ...country,
    image: country.name === 'UAE' ? uae_image : oman_flag,
    comingSoon: country.name === 'OMAN',
  }));

  const handleCountryClick = (country) => {
    // if (country.comingSoon) return;

    if (isNavigating) return;

    setIsNavigating(true);
    localStorage.setItem('preferredCountry', country.url);
    setTimeout(() => {
      window.location.href = country.url;
    });
    // window.location.href = country.url;
  };

  if (isNavigating) {
    return <div>Loading...</div>;
  }

  const openUrl = (url) => {
    console.log('i am here', url);
    const newWindow = window.open(url, '_blank');
    if (newWindow) newWindow.opener = null;
  };

  return (
    <div>
      <div className="container-fluid landing_pagebg">
        <div className="d-flex align-items-center justify-content-center min-vh-100">
          <div className="text-center my-5 py-4">
            {/* <div className="Star_loggo mx-auto">
              <img src={starLogo} />
            </div> */}

            <div className="my-4">
              <h4 className="mb-3 mobile_font">PLEASE SELECT YOUR COUNTRY</h4>
              <div className="country_name_container d-flex justify-content-between align-items-center mx-auto">
                {/* <div className="uae_d"><img src={uae_image}/></div>
                <div className="oman_o"><img src={oman_flag}/></div> */}
                {countries.map((country, index) => (
                  <div
                    key={index}
                    className="uae_d mx-4"
                    onClick={() => handleCountryClick(country)}
                    style={{
                      cursor: 'pointer',
                      opacity: country.comingSoon ? 0.9 : 1,
                    }}
                  >
                    <img
                      src={country.image}
                      alt={country.name}
                      className="country-flag"
                      style={{ cursor: 'pointer' }}
                    />
                    <h5 className="mt-2">{country.name}</h5>
                  </div>
                ))}
              </div>

              <div className="col-lg-12 mx-auto landingpage-text">
                By continuing to this website, you acknowledge and agree to our
                Terms and Conditions, Privacy Policy, and Terms of Use.
                <br />
                To enhance your experience, cookies may be used to automatically
                redirect you to your preferred country’s version of the site on
                future visits.{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountrySelection;

const getEnvironment = () => {
  const hostname = window.location.hostname;

  if (hostname.includes('localhost')) {
    return 'localhost';
  } else if (
    hostname.endsWith('.brij.tech') ||
    hostname.endsWith('.nuviotech.co')
  ) {
    return 'test';
  } else {
    return 'live';
  }
};
